import { useState } from "react";

export const CityAutocomplete = ({
  label,
  value,
  onSearch, 
  onChange,
  onSelect,
  isError,
  isOptional,
}) => {
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const borderColor = !isError ? "border-green-600" :
    isOptional ? "border-gray-600" :
      "border-red-600";

  const handleChange = async (e) => {
    const userInput = e.target.value;
    onChange(userInput);

    if (userInput.length > 2) {
      setIsLoading(true);
      setShowSuggestions(true);

      try {
        const results = await onSearch(userInput);
        setSuggestions(results);
      } catch (error) {
        console.error("Errore nella ricerca città:", error);
        setSuggestions([]);
      } finally {
        setIsLoading(false);
      }
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const handleSelect = (city) => {
    onSelect(city);
    setSuggestions([]);
    setShowSuggestions(false);
  };

  return (
    <div className="relative w-full">
      <div className="relative">
        <input
          type="text"
          value={value}
          onChange={handleChange}
          onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
          className={`border-2 p-2 w-full pr-10 ${borderColor} focus:outline-none`}
          placeholder={label}
          autoComplete="off"
        />
        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
          {isLoading ? (
            <svg
              className="animate-spin h-5 w-5 text-orange-500"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24">
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          ) : (
            <svg
              className="w-5 h-5 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          )}
        </div>
      </div>

      {showSuggestions && suggestions.length > 0 && (
        <ul className="absolute z-50 w-full bg-white border border-gray-300 max-h-60 overflow-y-auto shadow-lg mt-1 list-none p-0 text-left">
          {suggestions.map((city) => (
            <li
              key={city.id}
              onClick={() => handleSelect(city)}
              className="p-2 hover:bg-orange-100 cursor-pointer text-gray-700 font-medium border-b border-gray-100 last:border-0">
              {city.nome} ({city.provincia})
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
